(function () {
  var directiveId = "dateTimePicker";

  //Prevent datetime picker from lingering around if you press escape in certain situations.
  function onDocumentKeyPress(event) {
    if(event.keyCode === 27) {
      angular.element(".datetimepicker").css("display", "none");
    }
  }

  //requires jquery.scrollTableBody-1.0.0.js
  angular
    .module("app")
    .directive(directiveId, ["$document", function ($document) {
      return {
        restrict: "A",
        replace: true,
        scope: true,
        link: function (scope, element, attrs /*, ngModel*/ ) {
          //var input = element.find('input');
          var pickerOpt = {
            format: "mm/dd/yyyy hh:ii",
            minView: 0,
            maxView: 3,
            showMeridian: false,
            autoclose: true,
            todayHighlight: true,
            bootcssVer: 3,
            pickerPosition: "bottom-right"
          };
          var iconClass = "glyphicon-th";
          switch (attrs.dateTimePicker) {
            case "date":
              pickerOpt.minView = 2;
              pickerOpt.format = "mm/dd/yyyy";
              break;
            case "time":
              pickerOpt.maxView = 1;
              pickerOpt.startView = 1;
              pickerOpt.format = "H:ii P";
              pickerOpt.showMeridian = true;
              iconClass = "glyphicon-time";
              pickerOpt.pickerPosition = "bottom-right dontshowdate";
              break;
          }
          element.find(".glyphicon").addClass(iconClass);
          element.datetimepicker(pickerOpt);

          //Prevent datetime picker from lingering around if you press escape in certain situations.
          //We first remove the previous event so it doesn't get fired multiple times for multiple datetime directives
          $document.off("keydown", onDocumentKeyPress);
          $document.on("keydown", onDocumentKeyPress);

          scope.$on("$destroy", function () {
            //On destroy of whatever scope uses this directive, we should unbind the function from the event, otherwise it will persist and leak memory
            $document.off("keydown", onDocumentKeyPress);
            //If using this directive we must manually remove the datetime picker we created, on scope destroy - otherwise, old datetimepicker divs will not be removed from <body>,
            //and they will pile up everytime user navigates from and to the page, causing memory leaks over time.
            element.datetimepicker("remove");
          });

          //element.bind('blur keyup change', function () {
          //  scope.ngModel = input.val();
          //});
        }
      };
    }]);

})();




// WEBPACK FOOTER //
// ./app/components/datetimepick.directive.js